import React from 'react';

import { useSelector } from 'react-redux';
import { isAccountUiOptionSet } from 'src/helpers/conditions/account';
import { CreatePage } from './CreatePageV2';
import OGCreatePage from './CreatePage';

export default function (props) {
  const hasSubaccountSwitcher = useSelector(isAccountUiOptionSet('subaccount_switcher'));

  return hasSubaccountSwitcher ? <CreatePage {...props} /> : <OGCreatePage {...props} />;
}
